import { render, staticRenderFns } from "./FillClaimTable.vue?vue&type=template&id=b2834d56&scoped=true"
import script from "./FillClaimTable.vue?vue&type=script&lang=js"
export * from "./FillClaimTable.vue?vue&type=script&lang=js"
import style0 from "./FillClaimTable.vue?vue&type=style&index=0&id=b2834d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2834d56",
  null
  
)

export default component.exports